import { ValidationError } from '@dte/otw-utils-validation/src/ValidationError';
import type { CustomerReportDataV3 } from '../../../../report/CustomerReport';
import type { EligibilityResult } from '../../../interfaces/api/EligibilityResult';
import type { PremiseDataDocument } from '../../../interfaces/containers/premises/PremiseData';
import type { ValidatedCustomerReportData } from '../../../interfaces/containers/premises/ValidatedCustomerReportData';
import { getPremiseEligibilityResult } from '../../../premises/data/attributes/eligibility/getPremiseEligibilityResult';
import { getReportableCallCodes } from '../../reportedCall/getCallCodeDetails';
import { doesCallCodeMatchReportV1 } from '../symptomsToCallCode/matchesSymptoms';
import { doesCallCodeMatchReportV3 } from './matchesSymptomsV3';

function getCallCodeFromReportV1(
	report: ValidatedCustomerReportData,
	eligibility: EligibilityResult | undefined,
): string | undefined {
	const codes = getReportableCallCodes();

	for (const code of codes) {
		const match = doesCallCodeMatchReportV1(report, code, eligibility);
		if (match) {
			return code;
		}
	}

	return undefined;
}

export function getCallCodeFromReportV3(
	report: CustomerReportDataV3,
	masterData?: PremiseDataDocument,
): string | undefined {
	const codes = getReportableCallCodes();

	for (const code of codes) {
		const match = doesCallCodeMatchReportV3(report, code, masterData);
		if (match) {
			return code;
		}
	}

	return undefined;
}

export function getCallCodeFromReport(
	report: ValidatedCustomerReportData | CustomerReportDataV3,
	masterData?: PremiseDataDocument,
): string {
	let callCode: string | undefined;

	if (report?.version === 3) {
		callCode = getCallCodeFromReportV3(report as CustomerReportDataV3, masterData);
	} else {
		const eligibility = getPremiseEligibilityResult(masterData);
		callCode = getCallCodeFromReportV1(report as ValidatedCustomerReportData, eligibility);
	}

	if (!callCode) {
		throw new ValidationError('Unable to determine call code from customer report');
	}

	return callCode;
}
